import {useState} from "react";

const numeral = require('numeral')

/**
 * Hook to rerender function component.
 */
export function useForceFunctionComponentUpdate() {
  const [, updateState] = useState();
  return () => updateState({})
}


export function formatCurrency(value: number | string) {
  return numeral(value).format('O a')
}
